import React from 'react';

const MiscTab = ({ formData, handleNestedInputChange, FormField }) => {
  return (
    <div className="bg-white/95 backdrop-blur-xl border border-white/20 shadow-2xl shadow-slate-200/50 rounded-3xl p-8 overflow-hidden relative">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50/40 via-transparent to-gray-50/40 pointer-events-none" />

      {/* Header */}
      <div className="relative flex items-center gap-4 mb-8">
        <div className="w-14 h-14 bg-gradient-to-br from-slate-500 to-slate-700 rounded-2xl flex items-center justify-center shadow-lg shadow-slate-500/30">
          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <div>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">Additional Information</h2>
          <p className="text-slate-500 mt-1">Security credentials and visa information</p>
        </div>
      </div>

      <div className="relative space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <FormField
            id="known_traveler_number"
            label="Known Traveler Number (TSA PreCheck)"
            value={formData.travel_documents?.known_traveler_number || ''}
            onChange={(e) => handleNestedInputChange('travel_documents', 'known_traveler_number', e.target.value)}
            placeholder="KTN number"
          />

          <div className="space-y-2">
            <label htmlFor="global_entry" className="text-sm font-semibold text-slate-700">Global Entry</label>
            <select
              value={formData.travel_documents?.global_entry ? "yes" : "no"}
              onChange={(e) => handleNestedInputChange('travel_documents', 'global_entry', e.target.value === "yes")}
              className="w-full h-12 px-4 bg-white border border-slate-200 rounded-xl cursor-pointer
                focus:border-violet-400 focus:ring-4 focus:ring-violet-100 focus:shadow-lg focus:shadow-violet-100/50
                hover:border-slate-300 hover:shadow-sm
                transition-all duration-200 ease-out"
            >
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>
        </div>

        <div className="space-y-2">
          <label htmlFor="visa_info" className="text-sm font-semibold text-slate-700">Visa Information</label>
          <textarea
            id="visa_info"
            value={formData.travel_documents?.visa_info || ''}
            onChange={(e) => handleNestedInputChange('travel_documents', 'visa_info', e.target.value)}
            className="w-full h-28 px-4 py-3 bg-white border border-slate-200 rounded-xl resize-none
              focus:border-violet-400 focus:ring-4 focus:ring-violet-100 focus:shadow-lg focus:shadow-violet-100/50
              hover:border-slate-300 hover:shadow-sm
              transition-all duration-200 ease-out placeholder:text-slate-400"
            placeholder="Visa information, restrictions, or special document requirements"
          />
        </div>
      </div>
    </div>
  );
};

export default MiscTab;
